var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "module dt-episode" },
    [
      _vm.nav && _vm.nav.length
        ? [
            _vm.lastDate
              ? _c("h3", [
                  _vm._v("\n      选集"),
                  _c("span", [
                    _vm._v("更新至第" + _vm._s(_vm.lastDate) + "期"),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "dt-episode-wrap zy-select" }, [
              _c("div", { staticClass: "dt-episode-choose" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selected,
                        expression: "selected",
                      },
                    ],
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selected = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.selectChange,
                      ],
                    },
                  },
                  _vm._l(_vm.nav, function (item, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: index } },
                      [_vm._v("\n            " + _vm._s(item) + "\n          ")]
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dt-epitasis-detail" },
        [
          _vm.showList && _vm.showList.length
            ? [
                _c(
                  "div",
                  { staticClass: "dt-epitasis-detail-list" },
                  _vm._l(_vm.showList, function (item, index) {
                    return _c(
                      "a",
                      {
                        key: index,
                        attrs: {
                          href: _vm.playUrl(item),
                          uigs: "play_" + item.date,
                          uigsparams: `play_type=lvideo&play_url=${encodeURIComponent(
                            item.playlink
                          )}&play_site=${_vm.site}`,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "img" },
                          [
                            _c("Image-1", {
                              attrs: {
                                src: _vm.getResizePicUrl(
                                  item.picurl,
                                  115,
                                  65,
                                  200839
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "tag-time" }, [
                              _vm._v(_vm._s(item.duration)),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "info" }, [
                          _c("p", [_vm._v(_vm._s(item.title))]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  item.date.substring(0, 4) +
                                    "-" +
                                    item.date.substring(4, 6) +
                                    "-" +
                                    item.date.substring(6, 8)
                                ) +
                                "期\n            "
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showList && _vm.showList.length
            ? _c(
                "a",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showMoreBtn,
                      expression: "showMoreBtn",
                    },
                  ],
                  staticClass: "dt-more down",
                  attrs: { href: "javascript:void(0);" },
                  on: { click: _vm.loadMore },
                },
                [_c("span", [_vm._v("更多往期节目")])]
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }